import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import ItemList from 'flarum/common/utils/ItemList';
import SignUpModal from 'flarum/forum/components/SignUpModal';
const SHOW_BLOOD_DONATION = false;
const CATEGORIES = [{
  key: 'all',
  label: 'Todo el Foro',
  labelEu: 'Foro osoa',
  icon: 'fas fa-th-large'
}, {
  key: 'athletic',
  label: 'Primer Equipo & Lezama',
  labelEu: 'Lehen Taldea & Lezama',
  icon: 'fas fa-shield-alt'
}, {
  key: 'colaboradores',
  label: 'Colaboradores',
  labelEu: 'Laguntzaileak',
  icon: 'fas fa-microphone-alt'
}, {
  key: 'juegos',
  label: 'Juegos & Porras',
  labelEu: 'Jokoak & Porrak',
  icon: 'fas fa-trophy'
}, {
  key: 'comunidad',
  label: 'Afición & Grada',
  labelEu: 'Zaletasuna & Harmaila',
  icon: 'fas fa-users'
}, {
  key: 'tercer-tiempo',
  label: 'Tercer Tiempo',
  labelEu: 'Hirugarren Denbora',
  icon: 'fas fa-coffee'
}];
const CATEGORY_SLUGS = {
  athletic: ['primer-equipo-masculino', 'primer-equipo-femenino', 'cantera-masculina', 'cantera-femenina', 'institucional'],
  colaboradores: ['proyecto-hadi', 'area-rojiblanca', 'athletic-club-info'],
  juegos: ['11-aldeanos', 'la-bolilla', 'valoracion-de-jugadores', 'ya-sabia-yo', 'recopilatorios'],
  comunidad: ['comunidad', 'zurigorris-de-plata', 'vascos-por-el-mundo'],
  'tercer-tiempo': ['otros-futbol', 'otros-deportes', 'mercadillo', 'offtopic', 'club-de-la-lucha']
};
const SECTION_INFO = {
  athletic: {
    title: 'Primer Equipo & Lezama',
    icon: 'fas fa-shield-alt',
    desc: 'Actualidad deportiva, San Mamés, cantera y estructura del club',
    color: '#EE2523'
  },
  colaboradores: {
    title: 'Colaboradores',
    icon: 'fas fa-microphone-alt',
    desc: 'Canales de análisis, podcasts, noticias y creadores amigos del foro',
    color: '#E65100'
  },
  juegos: {
    title: 'Juegos & Pronósticos de la Peña',
    icon: 'fas fa-trophy',
    desc: 'Acierta alineaciones, porras de partido y valoraciones de los leones',
    color: '#D97706'
  },
  comunidad: {
    title: 'Grada, Afición e Identidad',
    icon: 'fas fa-users',
    desc: 'Punto de encuentro zurigorri, peñas, proyectos y debate social',
    color: '#059669'
  },
  'tercer-tiempo': {
    title: 'El Tercer Tiempo & Polideportivo',
    icon: 'fas fa-coffee',
    desc: 'Otros equipos, polideportivo, mercadillo forero y charla distendida',
    color: '#4B5563'
  }
};
const COLLABORATOR_LOGOS = {
  'proyecto-hadi': '/assets/extensions/bizkaitarra-colaborations/proyecto_hadi_logo.webp',
  'area-rojiblanca': '/assets/extensions/bizkaitarra-colaborations/area_rojiblanca_logo.png',
  'athletic-club-info': '/assets/extensions/bizkaitarra-colaborations/athletic-info_logo.webp'
};
function hexToRgba(hex, alpha) {
  if (alpha === void 0) {
    alpha = 0.12;
  }
  if (!hex || typeof hex !== 'string') return "rgba(238, 37, 35, ".concat(alpha, ")");
  let clean = hex.replace('#', '').trim();
  if (clean.length === 3) {
    clean = clean.split('').map(c => c + c).join('');
  }
  if (clean.length !== 6) return "rgba(238, 37, 35, ".concat(alpha, ")");
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
}
function getGameUrl(slug) {
  if (!slug) return null;
  const cleanSlug = String(slug).toLowerCase().trim();
  const season = app.forum && app.forum.attribute('nagusiMatchRatingsLatestSeason') || '2026-2027';
  const clubSlug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
  if (cleanSlug === 'la-bolilla') {
    return "/la-bolilla/".concat(season, "/clasificacion");
  }
  if (cleanSlug === 'valoracion-de-jugadores') {
    return "/valoracion-".concat(clubSlug, "/").concat(season, "/clasificacion");
  }
  if (cleanSlug === '11-aldeanos') {
    return "/11-aldeanos/".concat(season, "/clasificacion");
  }
  return null;
}
function getTagCategory(slug) {
  if (!slug) return 'comunidad';
  for (const _ref of Object.entries(CATEGORY_SLUGS)) {
    var _ref2 = _slicedToArray(_ref, 2);
    const cat = _ref2[0];
    const slugs = _ref2[1];
    if (slugs.includes(slug)) return cat;
  }
  return 'comunidad';
}
function getLocalizedDescription(slug, defaultDescription) {
  if (!slug) return defaultDescription || '';
  const key = "nagusi-match-ratings.forum.tags.".concat(slug, ".description");
  const trans = app.translator.trans(key);
  if (trans && typeof trans === 'string' && trans !== key) {
    return trans;
  }
  if (Array.isArray(trans) && trans.length > 0 && trans[0] !== key) {
    return trans[0];
  }
  return defaultDescription || '';
}
export default function extendTagsPage(compat) {
  const TagsPage = compat['tags/components/TagsPage'] || flarum.extensions['flarum-tags'] && flarum.extensions['flarum-tags'].TagsPage;
  if (!TagsPage) return;
  extend(TagsPage.prototype, 'oninit', function () {
    this.tagsSelectedCategory = 'all';
  });
  extend(TagsPage.prototype, 'sidebar', function (vnode) {
    if (vnode && vnode.attrs) {
      vnode.attrs.className = (vnode.attrs.className || '') + ' TagsPage-nav';
    }
  });
  override(TagsPage.prototype, 'hero', function () {
    const clubSlug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const primaryTeamName = app.forum && app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Aurrera Athletic';
    const isReal = clubSlug === 'real-sociedad';
    const isEu = app.translator && app.translator.locale === 'eu';
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.remove('preset-athletic', 'preset-real-sociedad');
      document.body.classList.add("preset-".concat(clubSlug));
    }
    const logoUrl = isReal ? '/assets/brand/reala_logo.webp' : '/assets/brand/aurrera_athletic_logo_cabecera.webp';
    const heroTitle = isReal ? 'Txuriurdin Aurrera' : 'AURRERA ATHLETIC';
    const subtitle = isReal ? 'Errealzaleen tokia' : SHOW_BLOOD_DONATION ? app.translator.trans('nagusi-match-ratings.forum.blood_donation.subtitle') : 'Athletic zaleen tokia';
    const signupText = isReal ? ' Únete a la familia txuri-urdin' : ' Únete a la familia zurigorri';
    return m('div', {
      className: "".concat(isReal ? 'erreala' : 'athletic', "-full-header TagsHero-unified")
    }, [m('div', {
      className: "".concat(isReal ? 'erreala' : 'athletic', "-container")
    }, [m('div', {
      className: "".concat(isReal ? 'erreala' : 'athletic', "-logo")
    }, m(Link, {
      href: app.route('index')
    }, m('img', {
      src: logoUrl,
      alt: "".concat(primaryTeamName, " - ").concat(heroTitle)
    }))), m('div', {
      className: "".concat(isReal ? 'erreala' : 'athletic', "-text")
    }, [m('span', {
      className: 'hero-title-fallback'
    }, heroTitle), m('p', subtitle), m('div', {
      className: 'header-buttons'
    }, [SHOW_BLOOD_DONATION ? m(Link, {
      className: 'Button support-button blood-donation-button',
      href: '/d/919-se-necesita-sangre-en-bizkaia'
    }, [m('i', {
      className: 'fas fa-tint',
      style: {
        color: '#e02424',
        marginRight: '8px'
      }
    }), app.translator.trans('nagusi-match-ratings.forum.blood_donation.button')]) : !app.session.user ? m('button', {
      type: 'button',
      className: 'Button Button--primary register-button',
      onclick: () => app.modal.show(SignUpModal)
    }, [m('i', {
      className: 'fas fa-user-plus'
    }), signupText]) : app.forum.attribute('nagusiMatchRatingsEnableDonations') !== false ? m(Link, {
      className: 'Button support-button',
      href: "/ayuda-aurrera-".concat(clubSlug)
    }, [m('i', {
      className: 'fas fa-hands-helping'
    }), ' Ayúdanos gratis']) : null])])]), m('div', {
      className: 'TagsHero-filterBar'
    }, [m('div', {
      className: 'TagsHero-categories'
    }, [CATEGORIES.map(cat => {
      const isActive = (this.tagsSelectedCategory || 'all') === cat.key;
      const label = isEu ? cat.labelEu : isReal && cat.key === 'athletic' ? 'Primer Equipo & Zubieta' : cat.label;
      return m('button', {
        type: 'button',
        key: cat.key,
        className: 'TagsHero-catBtn' + (isActive ? ' active' : ''),
        onclick: () => {
          this.tagsSelectedCategory = cat.key;
          m.redraw();
        }
      }, [m('i', {
        className: cat.icon
      }), m('span', label)]);
    })])])]);
  });
  const renderTagCard = tag => {
    const slug = tag.slug ? tag.slug() : '';
    const name = tag.name ? tag.name() : '';
    const rawDesc = tag.description ? tag.description() : '';
    const description = getLocalizedDescription(slug, rawDesc);
    const color = tag.color && tag.color() || '#EE2523';
    const iconClass = tag.icon && tag.icon() || 'fas fa-futbol';
    const count = tag.discussionCount && tag.discussionCount() || 0;
    const lastPostedDiscussion = tag.lastPostedDiscussion ? tag.lastPostedDiscussion() : null;
    const isGame = ['11-aldeanos', 'la-bolilla', 'valoracion-de-jugadores'].includes(slug);
    const logoSrc = COLLABORATOR_LOGOS[slug];
    const isColab = !!logoSrc;
    const gameUrl = isGame ? getGameUrl(slug) : null;
    const targetUrl = gameUrl || (app.route && app.route.tag ? app.route.tag(tag) : "/t/".concat(slug));
    const children = tag.children && tag.children() || [];
    const isEu = app.translator && app.translator.locale === 'eu';
    return m('li', {
      key: tag.id(),
      className: 'TagTile ' + (isGame ? 'TagTile--game ' : '') + (isColab ? 'TagTile--colab ' : ''),
      style: {
        '--tag-accent': color
      }
    }, [m('div', {
      className: 'TagTile-stripe',
      style: {
        background: color
      }
    }), m('div', {
      className: 'TagTile-cardBody'
    }, [m('div', {
      className: 'TagTile-top'
    }, [m('div', {
      className: 'TagTile-iconBubble' + (logoSrc ? ' TagTile-iconBubble--logo' : ''),
      style: logoSrc ? {
        background: '#ffffff',
        border: '1px solid rgba(0, 0, 0, 0.08)'
      } : {
        color: color,
        background: hexToRgba(color, 0.12)
      }
    }, logoSrc ? m('img', {
      src: logoSrc,
      alt: name,
      className: 'TagTile-logoImg'
    }) : m('i', {
      className: iconClass
    })), m('div', {
      className: 'TagTile-titleMeta'
    }, [m(Link, {
      className: 'TagTile-titleLink',
      href: targetUrl
    }, [m('h3', {
      className: 'TagTile-name'
    }, name)]), m('div', {
      className: 'TagTile-badgeRow'
    }, [!isGame ? m('span', {
      className: 'TagTile-countBadge'
    }, [m('i', {
      className: 'far fa-comments'
    }), m('span', " ".concat(count, " ").concat(count === 1 ? isEu ? 'gai' : 'debate' : isEu ? 'gai' : 'debates'))]) : null, isGame ? m('span', {
      className: 'TagTile-gameBadge'
    }, [m('i', {
      className: 'fas fa-trophy'
    }), m('span', isEu ? ' Joko Ofiziala' : ' Juego Oficial')]) : null, isColab ? m('span', {
      className: 'TagTile-colabBadge'
    }, [m('i', {
      className: 'fas fa-handshake'
    }), m('span', isEu ? ' Laguntzailea' : ' Colaborador')]) : null])])]), description ? m('p', {
      className: 'TagTile-description',
      title: description
    }, description) : null, children && children.length > 0 ? m('div', {
      className: 'TagTile-children'
    }, [m('span', {
      className: 'TagTile-childrenLabel'
    }, isEu ? 'Azpiatalak:' : 'Subforos:'), m('div', {
      className: 'TagTile-childrenList'
    }, [children.map(child => m(Link, {
      key: child.id(),
      className: 'TagTile-childChip',
      href: app.route.tag(child)
    }, [child.icon() ? m('i', {
      className: child.icon()
    }) : null, m('span', child.name())]))])]) : null]), /* Para los 3 juegos oficiales no se muestra el último post, sino una llamada a la acción hacia el juego */
    isGame ? m(Link, {
      className: 'TagTile-footer TagTile-footer--gameAction',
      href: gameUrl,
      title: "Ir a ".concat(name)
    }, [m('div', {
      className: 'TagTile-lastInfo'
    }, [m('span', {
      className: 'TagTile-gameActionTitle'
    }, [m('i', {
      className: 'fas fa-trophy'
    }), m('span', isEu ? ' Parte hartu jokoan' : ' Participar en el juego')]), m('span', {
      className: 'TagTile-gameActionSubtitle'
    }, isEu ? 'Ikusi sailkapena eta pronostikoak' : 'Ver clasificación y pronósticos')]), m('i', {
      className: 'fas fa-chevron-right TagTile-footerArrow'
    })]) : lastPostedDiscussion ? m(Link, {
      className: 'TagTile-footer',
      href: app.route.discussion(lastPostedDiscussion, lastPostedDiscussion.lastPostNumber()),
      title: lastPostedDiscussion.title()
    }, [m('div', {
      className: 'TagTile-lastInfo'
    }, [m('span', {
      className: 'TagTile-lastTitle'
    }, lastPostedDiscussion.title()), m('span', {
      className: 'TagTile-lastTime'
    }, [m('i', {
      className: 'far fa-clock'
    }), humanTime(lastPostedDiscussion.lastPostedAt())])]), m('i', {
      className: 'fas fa-chevron-right TagTile-footerArrow'
    })]) : m('div', {
      className: 'TagTile-footer TagTile-footer--empty'
    }, [m('span', {
      className: 'TagTile-emptyText'
    }, [m('i', {
      className: 'fas fa-seedling'
    }), m('span', isEu ? ' Oraindik ez dago azken mezurik' : ' Sin debates recientes todavía')])])]);
  };
  override(TagsPage.prototype, 'contentItems', function () {
    const items = new ItemList();
    if (this.loading) {
      items.add('loading', m(LoadingIndicator));
      return items;
    }
    const allTags = this.tags || [];
    const selectedCat = this.tagsSelectedCategory || 'all';
    const isEu = app.translator && app.translator.locale === 'eu';
    let filteredTags = allTags;
    if (selectedCat !== 'all') {
      const allowedSlugs = CATEGORY_SLUGS[selectedCat] || [];
      filteredTags = filteredTags.filter(t => allowedSlugs.includes(t.slug())).sort((a, b) => allowedSlugs.indexOf(a.slug()) - allowedSlugs.indexOf(b.slug()));
    }
    if (filteredTags.length === 0) {
      items.add('no-results', m('div', {
        className: 'TagsPage-emptyState'
      }, [m('div', {
        className: 'TagsPage-emptyIcon'
      }, m('i', {
        className: 'fas fa-folder-open'
      })), m('h3', isEu ? 'Ez da atalik aurkitu' : 'No se ha encontrado ninguna sección'), m('p', isEu ? 'Ez dago atalik kategoria honetan.' : 'No hay secciones disponibles en esta categoría.'), m('button', {
        type: 'button',
        className: 'Button Button--primary TagsPage-resetBtn',
        onclick: () => {
          this.tagsSelectedCategory = 'all';
          m.redraw();
        }
      }, isEu ? 'Atal guztiak ikusi' : 'Ver todas las secciones')]), 100);
      return items;
    }

    // Si estamos viendo "all", agrupamos por secciones temáticas
    if (selectedCat === 'all') {
      const groupKeys = ['athletic', 'colaboradores', 'juegos', 'comunidad', 'tercer-tiempo'];
      const assignedSlugs = new Set();
      groupKeys.forEach((key, index) => {
        const slugs = CATEGORY_SLUGS[key] || [];
        const groupTags = allTags.filter(t => slugs.includes(t.slug())).sort((a, b) => slugs.indexOf(a.slug()) - slugs.indexOf(b.slug()));
        slugs.forEach(s => assignedSlugs.add(s));
        if (groupTags.length === 0) return;
        const meta = SECTION_INFO[key];
        items.add("section-".concat(key), m('div', {
          className: 'TagsPage-group'
        }, [m('div', {
          className: 'TagsPage-groupHeader'
        }, [m('div', {
          className: 'TagsPage-groupIcon',
          style: {
            color: meta.color,
            background: hexToRgba(meta.color, 0.1)
          }
        }, [m('i', {
          className: meta.icon
        })]), m('div', {
          className: 'TagsPage-groupInfo'
        }, [m('h2', {
          className: 'TagsPage-groupTitle'
        }, meta.title), m('p', {
          className: 'TagsPage-groupDesc'
        }, meta.desc)]), m('span', {
          className: 'TagsPage-groupBadge'
        }, "".concat(groupTags.length, " ").concat(isEu ? 'txoko' : 'rincones'))]), m('ul', {
          className: 'TagTiles TagTiles--grid'
        }, groupTags.map(renderTagCard))]), 100 - index * 10);
      });

      // Si hubiera algún tag huérfano que no esté en ninguna categoría
      const orphans = allTags.filter(t => !assignedSlugs.has(t.slug()));
      if (orphans.length > 0) {
        items.add('section-other', m('div', {
          className: 'TagsPage-group'
        }, [m('div', {
          className: 'TagsPage-groupHeader'
        }, [m('div', {
          className: 'TagsPage-groupIcon'
        }, m('i', {
          className: 'fas fa-folder'
        })), m('div', {
          className: 'TagsPage-groupInfo'
        }, [m('h2', {
          className: 'TagsPage-groupTitle'
        }, isEu ? 'Beste Atal Batzuk' : 'Otras Secciones'), m('p', {
          className: 'TagsPage-groupDesc'
        }, isEu ? 'Foroko beste txokoak' : 'Más rincones y temas del foro')]), m('span', {
          className: 'TagsPage-groupBadge'
        }, "".concat(orphans.length, " ").concat(isEu ? 'txoko' : 'rincones'))]), m('ul', {
          className: 'TagTiles TagTiles--grid'
        }, orphans.map(renderTagCard))]), 10);
      }
      return items;
    }

    // Si hay filtro activo por categoría
    const catInfo = selectedCat !== 'all' ? SECTION_INFO[selectedCat] : null;
    items.add('filter-results', m('div', {
      className: 'TagsPage-filteredResults'
    }, [m('div', {
      className: 'TagsPage-resultsHeader'
    }, [m('div', {
      className: 'TagsPage-resultsLeft'
    }, [m('h2', {
      className: 'TagsPage-resultsTitle'
    }, catInfo ? catInfo.title : 'Todas las secciones'), m('span', {
      className: 'TagsPage-resultsCount'
    }, "".concat(filteredTags.length, " ").concat(filteredTags.length === 1 ? isEu ? 'atal' : 'sección' : isEu ? 'atal' : 'secciones'))]), m('button', {
      type: 'button',
      className: 'Button TagsPage-clearFiltersBtn',
      onclick: () => {
        this.tagsSelectedCategory = 'all';
        m.redraw();
      }
    }, [m('i', {
      className: 'fas fa-undo-alt'
    }), m('span', isEu ? ' Denak ikusi' : ' Ver todas las secciones')])]), m('ul', {
      className: 'TagTiles TagTiles--grid'
    }, filteredTags.map(renderTagCard))]), 100);
    return items;
  });

  // Anulamos la nube antigua ya que todos los tags ahora se muestran en tarjetas interactivas
  override(TagsPage.prototype, 'cloudView', function () {
    return null;
  });
}